// extracted by mini-css-extract-plugin
module.exports = {"account":"account_account__swOdk","profile":"account_profile__7707N","circle":"account_circle__y4MJm","loading":"account_loading__lajGP","arrow":"account_arrow__sjIF9"};